import { Grid, Typography } from '@material-ui/core'
import { DownloadForOffline } from '@mui/icons-material'
import React from 'react'
import { environment } from '../../environments/environment';
import pdfIcon from "../../assets/img/PDFIcon.svg"

const { apiPath } = environment;

const UploadedFiles = ({ data }) => {
    let { files, head, path } = data

    return (
        <div className="mt30">
            <span style={{ fontWeight: "bold", fontSize: "12px" }}>Uploaded documents</span>
            <div
                className="incident-uploaded-documents"
                style={{ display: "grid", gridTemplateColumns: "50% 50%", gap: "10px", marginTop: "20px" }}
            >
                {files.length ? (
                    files.map((name) => {
                        console.log(`${apiPath}/${path}&name=${name}`);
                        return <div style={{ background: "white", padding: "10px", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "5px", borderRadius: "5px", width: "90%" }} >

                            <img src={pdfIcon} />
                            <a
                                href={`${apiPath}/${path}&name=${name}`}
                                download
                                className='FileName'
                            >
                                {name}
                            </a>
                            <DownloadForOffline style={{ color: "gray" }} />


                            {/* <Grid className="" style={{ background: "white", padding: "10px" }}>

                                <Grid className="">
                                    <a
                                        href={`${apiPath}/${path}&name=${name}`}
                                        download
                                    >
                                        {name}
                                    </a>
                                </Grid>
                                <DownloadForOffline style={{ marginTop: "-10px", color: "gray" }} />
                            </Grid> */}
                        </div>
                    })
                ) : (
                    <Grid>No files found</Grid>
                )}
            </div>
        </div>
    )
}

export default UploadedFiles